import React from "react";
import Image from "next/image";
import classNames from "lib/classNames";
import Body from "components/Body";

export default function ParagraphImageText({ data }) {
  return (
    <div>
      {data.field_title && (
        <h2 className="mb-8 font-important font-bold text-xl">
          {data.field_title}
        </h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <figure className="aspect-w-16 aspect-h-10">
          <Image
            className={classNames(
              data.field_reverse_order && "order-last",
              "col-start-1 col-span-1"
            )}
            src={data.field_image.image_style_uri.large_scale}
            alt={data.field_image.resourceIdObjMeta.alt}
            layout="fill"
            objectFit="cover"
          />
          {data.field_image.resourceIdObjMeta.title && (
            <figcaption className="absolute bottom-0 left-0 px-4 py-2 bg-gray-300 text-white">
              {data.field_image.resourceIdObjMeta.title}
            </figcaption>
          )}
        </figure>
        <div
          className={classNames(
            data.field_reverse_order && "order-first",
            "col-span-1 md:col-span-2"
          )}
        >
          <div className="prose max-w-none">
            <Body value={data.field_text.value} />
          </div>
        </div>
      </div>
    </div>
  );
}
